import { useState, useEffect, useCallback } from 'react'
import { api } from '@/lib/api'

export function useItems() {
  const [items, setItems]     = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError]     = useState(null)

  const fetchItems = useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      const data = await api.items.list()
      setItems(data)
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => { fetchItems() }, [fetchItems])

  const createItem = useCallback(async (body) => {
    const newItem = await api.items.create(body)
    setItems(prev => [newItem, ...prev])
    return newItem
  }, [])

  const updateItem = useCallback(async (id, body) => {
    const updated = await api.items.update(id, body)
    setItems(prev => prev.map(i => (i.id === id ? updated : i)))
    return updated
  }, [])

  const removeItem = useCallback(async (id) => {
    await api.items.remove(id)
    setItems(prev => prev.filter(i => i.id !== id))
  }, [])

  return { items, loading, error, refetch: fetchItems, createItem, updateItem, removeItem }
}
